'use es6';

import { DropTarget } from 'react-dnd';
import DragTypes from 'simple-menus-core/enums/DragTypes';
import DropPositions from 'simple-menus-core/enums/DropPositions';
const target = {
  canDrop(props, monitor) {
    /* Can promote yourself */
    if (props.id === monitor.getItem().id) return true;
    return !props.isParentDragging;
  },
  drop(props, monitor) {
    const {
      moveNode,
      targetId,
      targetParentId,
      menuId
    } = props;
    const nodeId = monitor.getItem().id;
    moveNode(nodeId, targetId, targetParentId, DropPositions.BOTTOM, menuId);
  }
};
export default function menuDropTarget() {
  return Component => {
    return DropTarget(DragTypes.ADVANCED_MENUS_MENU_NODE, target, (connect, monitor) => ({
      connectDropTarget: connect.dropTarget(),
      isOver: monitor.isOver(),
      canDrop: monitor.canDrop()
    }))(Component);
  };
}